import React from "react";
import styles from "./MyAssetsCards.module.css";
import BalanceCard from "./BalanceCard";
import CumulativeInterestCard from "./CumulativeInterestCard";
import InterestEarnedCard from "./InterestEarnedCard";
import DepositWithdrawCard from "./DepositWithdrawCard";

/**
 * Four horizontally scrollable cards for My Assets left section:
 * 1. Balance – USDi balance, USD value, APY, NAV, Cumulative Interest, Accrued Interest
 * 2. Cumulative Interest Earned – line chart + total (same API as existing chart)
 * 3. Interest Earned – table from get_user_balance_solana
 * 4. Deposit / Withdraw History – table from get_user_history
 */
function MyAssetsCards({
  walletAddress,
  balance,
  usdValue,
  apyLabel,
  apyValue,
  navPerUsdi,
  cumulativeInterest,
  accruedInterest,
  isLoading,
  holderDataLoading,
  justCopied,
  onCopy,
  onShare,
  usdiTokenAddress,
}) {
  // For the Cumulative Interest Earned card, show the same cumulative
  // interest value as in the Balance card (not cumulative + accrued).
  const cumulativeTotal =
    cumulativeInterest != null ? Number(cumulativeInterest) : 0;
  const chartLoading = isLoading || holderDataLoading;

  return (
    <div className={styles.cardsScrollWrapper}>
      <BalanceCard
        balance={balance}
        usdValue={usdValue}
        apyLabel={apyLabel}
        apyValue={apyValue}
        navPerUsdi={navPerUsdi}
        cumulativeInterest={cumulativeInterest}
        accruedInterest={accruedInterest}
        isLoading={isLoading}
        justCopied={justCopied}
        onCopy={onCopy}
        onShare={onShare}
        usdiTokenAddress={usdiTokenAddress}
      />
      <DepositWithdrawCard walletAddress={walletAddress} maxRows={5} />
      <CumulativeInterestCard
        cumulativeTotal={cumulativeTotal}
        availableUSDI={balance}
        usdiValue={navPerUsdi}
        swapMainWalletAddress={walletAddress}
        isLoading={chartLoading}
      />
      <InterestEarnedCard
        walletAddress={walletAddress}
        currentApy={apyValue}
        maxRows={5}
      />
    </div>
  );
}

export default MyAssetsCards;
